import { IAdobeInteraction } from "@abbvie-epi/common/adobe-analytics";
import { LeaveModalAction } from "@abbvie-epi/common/enums";
import { Component, OnInit } from "@angular/core";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";
import { ContributorsService } from "../../services/contributors.service";

@Component({
    selector: "app-collaborators-publications",
    templateUrl: "./collaborators-publications.component.html",
    styleUrls: ["./collaborators-publications.component.scss"]
})
export class CollaboratorsPublicationsComponent implements OnInit {
    public usPancreatology: any;
    public abbvie: any;

    public dropdownToggle: boolean = false;

    public ContributorType = ContributorType;

    public publications: any = {
        "Christopher E Forsmark, MD":
            "https://pubmed.ncbi.nlm.nih.gov/?term=%28Forsmark+CE%5BAuthor%5D%29+AND+%28pancreas%5BText+Word%5D%29&sort=date&filter=datesearch.y_10&filter=datesearch.y_10",
        "Luis F Lara, MD":
            "https://pubmed.ncbi.nlm.nih.gov/?term=%28Lara+LF%5BAuthor%5D%29+AND+%28pancreas%5BText+Word%5D%29&sort=date&filter=datesearch.y_10&filter=datesearch.y_10",
        "Mohamed O Othman, MD":
            "https://pubmed.ncbi.nlm.nih.gov/?term=%28Othman+MO%5BAuthor%5D%29+AND+%28pancreas%5BText+Word%5D%29&sort=date&filter=datesearch.y_10&filter=datesearch.y_10",
        "Walter G Park, MD, MS":
            "https://pubmed.ncbi.nlm.nih.gov/?term=%28Park+WG%5BAuthor%5D%29+AND+%28pancreas%5BText+Word%5D%29&sort=date&filter=datesearch.y_10&filter=datesearch.y_10",
        "Vikesh K Singh, MD, MSc":
            "https://pubmed.ncbi.nlm.nih.gov/?term=%28Singh+VK%5BAuthor%5D%29+AND+%28pancreas%5BText+Word%5D%29&sort=date&filter=datesearch.y_10&filter=datesearch.y_10",
        "Dhiraj Yadav, MD, MPH":
            "https://pubmed.ncbi.nlm.nih.gov/?term=%28Yadav+D%5BAuthor%5D%29+AND+%28pancreas%5BText+Word%5D%29&sort=date&filter=datesearch.y_10&filter=datesearch.y_10"
    };

    public leavingSite: boolean = false;
    public url: string;

    private trackedUser: string | null = null;

    constructor(private contributorsService: ContributorsService, private analyticsHelper: AnalyticsHelperService) {}

    ngOnInit(): void {
        this.getContributors();
    }

    public toggleDropdown(name: string, type: ContributorType) {
        if (type === ContributorType.UsPancreatology) {
            const index: any = this.usPancreatology.findIndex((contributor: any) => contributor.name === name);
            if (!this.usPancreatology[index].dropdown) {
                this.trackContributorAccordion(name, type, "Expand");
            } else {
                this.trackContributorAccordion(name, type, "Close");
            }

            this.usPancreatology[index].dropdown = !this.usPancreatology[index].dropdown;
        } else if (type === ContributorType.Abbvie) {
            const index: any = this.abbvie.findIndex((contributor: any) => contributor.name === name);

            if (!this.usPancreatology[index].dropdown) {
                this.trackContributorAccordion(name, type, "Expand");
            } else {
                this.trackContributorAccordion(name, type, "Close");
            }

            this.abbvie[index].dropdown = !this.abbvie[index].dropdown;
        }
    }

    private trackContributorAccordion(name: string, type: ContributorType, action: "Expand" | "Close"): void {
        const analytics: IAdobeInteraction = {
            link: {
                name: `${name}: Research Interests - ${action}`,
                title: `Research Interests - ${action}`,
                type: "internal"
            },
            component: {
                name: "cta",
                position: "content",
                type: "content"
            },
            content: {
                type: "accordion"
            },
            interaction: {
                type: "link"
            }
        };

        if (type === ContributorType.UsPancreatology) {
            analytics.component!.title = "US pancreatology expert contributors";
        } else if (type === ContributorType.Abbvie) {
            analytics.component!.title = "AbbVie contributors";
        } else {
            return;
        }

        this.analyticsHelper.trackCustom(analytics);
    }

    private getContributors() {
        this.contributorsService.getData().subscribe((contributors: any) => {
            this.usPancreatology = contributors.usPancreatology;
            this.abbvie = contributors.abbvie;

            this.usPancreatology.forEach((contributor: any) => {
                contributor["dropdown"] = false;
            });
            this.abbvie.forEach((contributor: any) => {
                contributor["dropdown"] = false;
            });
        });
    }

    public track(id: string): void {
        this.analyticsHelper.trackInteraction(id);
    }

    public leaveSite(name: string) {
        this.url = this.publications[name];
        this.leavingSite = true;
        document.body.style.overflow = "hidden";

        this.trackedUser = name;

        const analytics: IAdobeInteraction = {
            link: {
                name: `${name}: Recent Publications`,
                title: "Recent Publications",
                type: "internal",
                url: this.url || ""
            },
            component: {
                name: "cta",
                title: "US pancreatology expert contributors",
                position: "content",
                type: "content"
            },
            content: {
                type: "link"
            },
            interaction: {
                type: "link"
            }
        };

        this.analyticsHelper.trackCustom(analytics);
    }

    public closeLeavingSiteModal(userAction: LeaveModalAction) {
        this.leavingSite = false;
        document.body.style.overflow = "scroll";

        if (!this.trackedUser) {
            return;
        }

        const analytics: IAdobeInteraction = {
            component: {
                name: "modal",
                title: "You are leaving this website",
                position: "content",
                type: "modal"
            },
            content: {
                type: "informational modal"
            },
            interaction: {
                type: "link"
            }
        };

        switch (userAction) {
            case LeaveModalAction.Yes:
                analytics.link = {
                    name: `${this.trackedUser}: Recent Publications - View`,
                    title: "Are you happy to continue?: Yes",
                    type: "external",
                    url: `${this.publications[this.trackedUser || ""]}`
                };
                break;

            case LeaveModalAction.No:
                analytics.link = {
                    name: `${this.trackedUser}: Recent Publications - Cancel`,
                    title: "Are you happy to continue?: No",
                    type: "information modal",
                    url: `${this.publications[this.trackedUser || ""]}`
                };
                break;
            case LeaveModalAction.Close:
                analytics.link = {
                    name: `${this.trackedUser}: Recent Publications - Cancel`,
                    title: "X",
                    type: "information modal",
                    url: `${this.publications[this.trackedUser || ""]}`
                };
                break;
            default:
                return;
        }

        this.analyticsHelper.trackCustom(analytics);

        this.trackedUser = "";
    }
}

export enum ContributorType {
    Abbvie = "abbvie",
    UsPancreatology = "usPancreatology"
}
